// extracted by mini-css-extract-plugin
export default {"orderFeedEmptyItem":"OrderNotFound_orderFeedEmptyItem__3kOH4","orderFeedEmptyButton":"OrderNotFound_orderFeedEmptyButton__XGJh3"};